export const SelectField = ({ field, register, errors, theme }) => (
  <select
    id={field.id}
    {...register(field.id, field.validation)}
    className={`${theme.input} ${errors[field.id] ? theme.inputError : ''}`}
    disabled={field.disabled}
  >
    <option value="">{field.placeholder || 'Select an option'}</option>
    {field.options?.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);